import { inject, injectable } from 'inversify'
import { SERVICE_TYPES } from '@/core/container/types'
import type { Resolvable } from '@/services/resolvers/types'
import type UserSettingsService from '@/services/domain/user/userSettingsService'

@injectable()
export default class EmailPriceResolver implements Resolvable {
  constructor(
    @inject(SERVICE_TYPES.UserSettingsService)
    private readonly userSettingsService: UserSettingsService,
  ) {}

  public async resolve() {
    const emailPrice = this.userSettingsService.currentUserSettingsOrNull()?.emailPrice
    if (!emailPrice) {
      await this.userSettingsService.fetchEmailPrice()
    }
  }
}
